const state = () => ({
  failedContracts: [],
  contracts: []
});

const getters = {
  failedContracts: state => {
    return state.failedContracts;
  },
  contracts: state => {
    return state.contracts;
  },
};

const actions = {
  async fetchFailedContracts({ commit }) {
    const { data } = await this.$http.get(`/contracts/failed`);
    commit("setFailedContracts", data);
  },
  async fetchContractsByClientId({ commit }, { id }) {
    const { data } = await this.$http.get(`/contracts/info`, {
      params: {
        'client-id': id,
      }
    });
    commit("setContracts", data);
  },
  async deleteContract({ commit }, { id }) {
    await this.$http.delete(`/contracts/delete/${id}`);
    commit("removeContract", id);
  },
  async updatecontract({ commit }, { id }) {
    await this.$http.patch(`/contracts/update/${id}/success`);
    commit("removeFailedContract", id);
  },
  async openContract({}, id) {
    const { data } = await this.$http.get(`/contracts/pdf/${id}`, {
      responseType: "arraybuffer"
    });
    const file = new Blob([data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  },
  async createContract({}, data) {
    await this.$http.post(`contracts/create`, data);
  },
};

const mutations = {
  setFailedContracts(state, data) {
    state.failedContracts = data;
  },
  setContracts(state, data) {
    state.contracts = data;
  },
  removeFailedContract(state, id) {
    state.failedContracts = state.failedContracts.filter(c => c.id != id);
  },
  removeContract(state, id) {
    state.contracts = state.contracts.filter(c => c.id != id);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
